import { useEffect, useState } from 'react';
import api from '../api';
import { serviceCategories as fallbackCategories } from './marketplace';

function normalizeCategory(item) {
  if (typeof item === 'string') {
    return { name: item, items: [] };
  }
  return {
    ...item,
    name: String(item?.name || '').trim(),
    items: Array.isArray(item?.items) ? item.items.map(String).filter(Boolean) : [],
  };
}

export default function useServiceCategories() {
  const [categories, setCategories] = useState(fallbackCategories);

  useEffect(() => {
    let active = true;
    api.get('/marketplace/categories', { timeout: 4500 })
      .then(response => {
      const next = Array.isArray(response.data?.categories)
          ? response.data.categories.map(normalizeCategory).filter(category => category.name)
          : [];
        if (active && Array.isArray(response.data?.categories)) setCategories(next);
      })
      .catch(() => {
        // Keep the built-in catalogue available while the API is waking up.
      });
    return () => { active = false; };
  }, []);

  return categories;
}
